/**
 *
 * Footer
 *
 */

import React from "react";
import styled from "styled-components";
import { Box } from "@mui/material";
import poweredBy from "../../../assets/images/powered-by.png";

const Logo = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 28px;
    display: block;
  }
`;

const PoweredSix = ({ className = "" }) => {
  return (
    <Logo
      href="https://coinmarketcap.com/currencies/six/markets/"
      target="_blank"
      rel="noreferrer"
      className={className}
    >
      <img src={poweredBy} alt="poweredBy" />
    </Logo>
  );
};

function Footer() {
  return (
    <Box
      sx={{
        flexShrink: 0,
        zIndex: 10,
        position: "relative",
        bottom: 0,
        width: "100%",
        left: 0,
        padding: "24px",
      }}
    >
      <PoweredSix />
    </Box>
  );
}

export default Footer;
